import {
    Component,
    OnInit,
    Input,
    EventEmitter,
    Output,
    ViewChild,
} from '@angular/core';
import { TriggerModel } from '@models/deal.model';
import { TogglerModel } from '@models/toggler.model';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { MeetingService } from '@services/metting.service';
import { FormSchemaModel } from '@models/formSchema.model';
import { DealTriggerService } from '@services/dealTriggers.service';
import { DateHelperService, HelpersService } from '@helpers/helpers';
import { Snackbar } from '@models/snackbar.model';
import { FormComponent } from 'flexiforms-library';
import { ServerDocsService } from '@services/server-docs.service';
import { MultiuploadFilesComponent } from '@shared/multiupload-files/multiupload-files.component';
import { CRUDService } from '@services/api-calls/crud.service';
import { SnackbarService } from '@services/snackbar.service';

@Component({
    selector: 'app-trigger-card',
    templateUrl: './trigger-card.component.html',
    styleUrls: ['./trigger-card.component.scss'],
})
export class TriggerCardComponent implements OnInit {
    @Input() trigger: TriggerModel;
    @Output() onSave = new EventEmitter<any>();

    public documentToggler: TogglerModel = new TogglerModel();
    public meetingToggler: TogglerModel = new TogglerModel();
    public formToggler: TogglerModel = new TogglerModel();
    public buttonModalText: string;
    public translateDocParams: any = {
        doc: '',
    };
    public translateStrings: any = {
        successMeeting: '',
    };

    // Form trigger
    public triggerForm: FormSchemaModel;
    public snackbar: Snackbar = new Snackbar();

    @ViewChild(FormComponent, { static: false })
    formComponent: FormComponent;

    @ViewChild(MultiuploadFilesComponent, { static: false })
    multiuploadComponent: MultiuploadFilesComponent;

    constructor(
        private translate: TranslateService,
        private datepipe: DatePipe,
        private meetingService: MeetingService,
        private dealTriggerService: DealTriggerService,
        private dateHelper: DateHelperService,
        private docService: ServerDocsService,
        private crudService: CRUDService,
        private snackbarService: SnackbarService
    ) {}

    ngOnInit(): void {
        if (this.trigger.type === 'form') {
            this.triggerForm = {
                title: null,
                text: null,
                background: null,
                form: this.trigger.data.form,
                tags: {},
            };
        }

        this.translate
            .get('FUNNEL.dealPage.triggers.buttons.meeting')
            .subscribe((translated: string) => {
                this.translateStrings.successMeeting = this.translate.instant(
                    'FUNNEL.dealPage.triggers.meetingSuccess'
                );

                switch (this.trigger.type) {
                    case 'doc':
                        this.translateDocParams.doc =
                            this.trigger.data.info_name;
                        this.buttonModalText = this.translate.instant(
                            'FUNNEL.dealPage.triggers.buttons.upload',
                            this.translateDocParams
                        );
                        break;
                    case 'meeting':
                        this.buttonModalText = translated;
                        break;
                    case 'form':
                        this.buttonModalText = this.translate.instant(
                            'FUNNEL.dealPage.triggers.buttons.form'
                        );
                        break;
                    default:
                        break;
                }
            });
    }

    doTriggerAction(action: string): void {
        switch (action) {
            case 'doc':
                this.documentToggler.open();
                this.multiuploadComponent.pbComponent.hide();
                break;
            case 'meeting':
                this.meetingToggler.open();
                break;
            case 'form':
                this.formToggler.open();
                break;
            default:
                break;
        }
    }
    downloadFile(): void {
        this.docService.getImage(this.trigger.data.step_file).subscribe(
            (response) => {
                const url = window.URL.createObjectURL(response);
                window.open(url);
            },
            (error) => {
                console.log(error);
                this.snackbar.show(
                    `ERROR ${error.status}:  ${error.statusText}`,
                    'error'
                );
            }
        );
    }

    getFileName(url: string) {
        const urlArray = url.split('/');
        return urlArray[urlArray.length - 1];
    }

    multiuploadCallback(files: File[]): void {
        const formData: FormData = new FormData();
        files.forEach((file, index) => {
            formData.append(`file_${index}`, file);
        });
        formData.append('trigger', this.trigger.id.toString());
        formData.append('access', localStorage.getItem('user-access'));
        this.crudService
            .run('create', 'trigger-actions', 'woct', null, null, formData)
            .subscribe(
                () => {
                    this.markAsCompleted();
                    this.snackbar.show('Todo bien', 'success');
                },
                (error) => {
                    console.log(error.error);
                    this.snackbar.show(error.error.detail, 'error');
                }
            );
    }

    onArrangeDate(event: any): void {
        let selectedRange = event.selectedRange;
        const coordinatorId = this.trigger.coordinator.id;
        const dealId = this.trigger.dealId;
        const date = this.datepipe.transform(selectedRange.start, 'yyyy-MM-dd');
        const time = this.datepipe.transform(
            this.dateHelper.convertDateToUTC(selectedRange.start),
            'HH:mm'
        );
        const data = {
            coordinator: coordinatorId,
            deal: dealId,
            date: date,
            time: time,
        };

        this.crudService
            .run('create', 'meetings', 'common', null, {}, data)
            .subscribe(
                () => {
                    const data = {
                        trigger: this.trigger.id,
                    };
                    this.crudService
                        .run(
                            'create',
                            'trigger-actions',
                            'common',
                            null,
                            {},
                            data
                        )
                        .subscribe(
                            () => {
                                this.snackbar.show(
                                    this.translateStrings.successMeeting,
                                    'success'
                                );
                            },
                            (error) => {
                                console.log(error);
                                this.snackbar.show(error.error.detail, 'error');
                            }
                        );
                    this.markAsCompleted();
                },
                (error) => {
                    console.log(error);
                    this.snackbar.show(error.error.detail, 'error');
                }
            );
    }

    onSaveForm(event: any): void {
        if (!event) {
            this.formToggler.close();
        } else {
            const triggerData = {
                trigger: this.trigger.id,
                content: {
                    form: event['schema']['form'],
                },
            };
            this.snackbar.show('¡Guardado!', 'success');

            this.crudService
                .run(
                    'create',
                    'trigger-actions',
                    'common',
                    null,
                    null,
                    triggerData
                )
                .subscribe(
                    () => {
                        this.markAsCompleted();
                    },
                    (error) => {
                        console.error(error.error);
                        this.snackbar.show(error.error.detail, 'error');
                    }
                );

            this.formToggler.close();
        }
    }

    markAsCompleted(): void {
        this.trigger.done();
        this.onSave.emit(this.trigger);
    }
}
